import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { InputMask } from "primereact/inputmask";
import { InputNumber } from "primereact/inputnumber";
import { AutoComplete } from "primereact/autocomplete";
import { Calendar } from "primereact/calendar";
import { Chips } from "primereact/chips";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import CountryService from "../provider/CountryService";

const InvalidStateDemo = () => {
    const [countries, setCountries] = useState<any>([]);
    const [filteredCountries, setFilteredCountries] = useState<any>(null);
    const [value1, setValue1] = useState<string>("");
    const [value2, setValue2] = useState<string>("");
    const [value3, setValue3] = useState<any>(null);
    const [value4, setValue4] = useState<string>("");
    const [value5, setValue5] = useState<string>("");
    const [value6, setValue6] = useState<any>(null);
    const [value7, setValue7] = useState<string>("");
    const [value8, setValue8] = useState<any>([]);
    const [value9, setValue9] = useState<any>(null);

    const cities = [
        { name: "New York", code: "NY" },
        { name: "Rome", code: "RM" },
        { name: "London", code: "LDN" },
        { name: "Istanbul", code: "IST" },
        { name: "Paris", code: "PRS" },
    ];

    useEffect(() => {
        const countryService = new CountryService();
        countryService.getCountries().then(countries => {
            setCountries(countries);
        });
    }, []);

    const searchCountry = (event: any) => {
        // in a real application, make a request to a remote url with the query and
        // return filtered results, for demo we filter at client side
        const filtered: any[] = [];
        const query = event.query;
        for (let i = 0; i < countries.length; i++) {
            const country = countries[i];
            if (country.name.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                filtered.push(country);
            }
        }
        setFilteredCountries(filtered);
    };

    return (
        <div className="grid floatlabel-demo">
            <div className="col-12">
                <div className="card p-fluid">
                    <h5>Invalid State</h5>
                    <p>All form components have an invalid state style to display the validation errors.</p>
                    <div className="grid">
                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="inputtext">InputText</label>
                                <InputText type="text" id="inputtext" value={value1} onChange={e => setValue1(e.target.value)} className="p-invalid" />
                            </div>
                            <div className="field">
                                <label htmlFor="autocomplete">AutoComplete</label>
                                <AutoComplete
                                    id="autocomplete"
                                    value={value5}
                                    onChange={e => setValue5(e.value)}
                                    suggestions={filteredCountries}
                                    completeMethod={searchCountry}
                                    field="name"
                                    className="p-invalid"></AutoComplete>
                            </div>
                            <div className="field">
                                <label htmlFor="calendar">Calendar</label>
                                <Calendar inputId="calendar" value={value6} onChange={e => setValue6(e.value)} className="p-invalid"></Calendar>
                            </div>
                            <div className="field">
                                <label htmlFor="chips">Chips</label>
                                <Chips id="chips" value={value8} onChange={e => setValue8(e.value)} className="p-invalid"></Chips>
                            </div>
                            <div className="field">
                                <label htmlFor="textarea">Textarea</label>
                                <InputTextarea
                                    id="textarea"
                                    rows={3}
                                    cols={30}
                                    value={value4}
                                    onChange={e => setValue4(e.target.value)}
                                    className="p-invalid"></InputTextarea>
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="inputmask">InputMask</label>
                                <InputMask id="inputmask" mask="99/99/9999" value={value2} onChange={e => setValue2(e.value)} className="p-invalid"></InputMask>
                            </div>
                            <div className="field">
                                <label htmlFor="inputnumber">InputNumber</label>
                                <InputNumber id="inputnumber" value={value3} onValueChange={e => setValue3(e.target.value)} className="p-invalid"></InputNumber>
                            </div>
                            <div className="field">
                                <label htmlFor="dropdown">Dropdown</label>
                                <Dropdown
                                    id="dropdown"
                                    options={cities}
                                    value={value7}
                                    onChange={e => setValue7(e.value)}
                                    optionLabel="name"
                                    className="p-invalid"></Dropdown>
                            </div>
                            <div className="field">
                                <label htmlFor="multiselect">MultiSelect</label>
                                <MultiSelect
                                    id="multiselect"
                                    options={cities}
                                    value={value9}
                                    onChange={e => setValue9(e.value)}
                                    optionLabel="name"
                                    className="p-invalid"></MultiSelect>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvalidStateDemo;
